import CourseProgressCarouselFetcher from '@/components/courseProgress/carousel/CourseProgressCarouselFetcher';
import useAuth from '@/data/hook/useAuth';
import { ListCourseProgressFilters } from '@/data/services/courseProgressServices';
import { ProgressStatusEnum } from '@/enums/ProgressStatusEnum';

export default function CourseProgressList({
  filters,
}: {
  filters: ListCourseProgressFilters;
}) {
  const { user } = useAuth();
  const studentId = user?.id;

  if (!studentId) {
    return null;
  }

  return (
    <div className="flex flex-col max-w-full gap-2.5">
      <CourseProgressCarouselFetcher
        section={ProgressStatusEnum.IN_PROGRESS}
        filters={filters}
        studentId={studentId}
      />
      <CourseProgressCarouselFetcher
        section={ProgressStatusEnum.CONCLUDED}
        filters={filters}
        studentId={studentId}
      />
    </div>
  );
}
